import { Link } from "gatsby"
import React, { useState, useEffect, useRef } from "react"
import { useLocation } from "@reach/router"
import { motion } from "framer-motion"
import tw, { styled } from "twin.macro"
import { useStateContext } from "@context/stateContext"
import { globalHistory } from "@reach/router"
import { letterSpacing } from "tailwindcss/defaultTheme"

const liVariants = {
  closed: {
    y: "-100%",
    opacity: 0,
    scale: 1,
    transition: {
      type: "tween",
      ease: "easeIn",
      duration: 0.4,
    },
  },
  open: {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: {
      type: "tween",
      ease: "circOut",
      duration: 0.25,
    },
  },
}
const ulVariants = {
  closed: {
    transition: {
      type: "tween",
      ease: "easeIn",
      duration: 0.2,
      staggerChildren: 0.05,
    },
  },
  open: {
    transition: {
      type: "tween",
      ease: "circOut",
      duration: 0.2,
      staggerChildren: 0.07,
    },
  },
}

function DesktopNavigation({ menuItems, className, pageScrolled }) {
  // ems)
  const location = useLocation()
  const locationPathName = location.pathname
  const [closedAll, setClosedAll] = useState(false)

  const { navbarHovered, unsetNavbarHovered } = useStateContext()

  useEffect(() => {
    return globalHistory.listen(({ action }) => {
      if (action === "PUSH") unsetNavbarHovered()
    })
  }, [unsetNavbarHovered])

  useEffect(() => {
    setClosedAll(true)
  }, [navbarHovered])
  return (
    <>

      <nav className={`${className} z-10`}>
        <ul className="flex p-0 m-0 lg:gap-7 3xl:gap-20">
          {menuItems.map(({ id, label, path, acfMegaMenu }) => (
            <MenuItem
              key={id}
              label={label}
              acfMegaMenu={acfMegaMenu}
              path={path}
              locationPathName={locationPathName}
              level={0}
              pageScrolled={pageScrolled}
              setClosedAll={setClosedAll}
              closedAll={closedAll}
            ></MenuItem>
          ))}
        </ul>
      </nav>
    </>
  )
}

export default DesktopNavigation

const MenuItem = ({
  id,
  label,
  path,
  acfMegaMenu,
  parentOpen,
  pageScrolled,
  parentRef,
  level,
  locationPathName,
  setClosedAll,
  closedAll,

}) => {

  const { setNavbarHovered } = useStateContext()
  const [open, setOpen] = useState(false)
  const toggleOpen = clickEvent => {
    if (level === 0 && !open) {
      setClosedAll(true)
      setTimeout(() => {
        setOpen(true)
        setNavbarHovered()
      }, 10)
    } else if (level > 0 && !open) {
      setOpen(!open)
    } else {
      setOpen(false)
    }

    clickEvent.stopPropagation()
   

  }
  
    return (
      <MenuListItem
        key={id}
        level={level}
        active={path === locationPathName}
        pageScrolled={pageScrolled}
        className={acfMegaMenu.columns != null ?  `level-${level} open-${open} active-${open}` : `level-${level} active-${open}`}
       
        onHoverStart={() => level === 0 && setOpen(true)}
        onHoverEnd={() => level === 0 && setOpen(false)}
      

        parentRef={parentRef ? parentRef : null}
        setClosedAll={setClosedAll}
        closedAll={closedAll}
      >
        { acfMegaMenu.columns == null && 
        <Link className={``} to={path} title={label} aria-label={label}>
          {label}
        </Link>
        }
         { acfMegaMenu.columns != null && 
        <button className={``}  title={label} aria-label={label}   onClick={clickEvent => {
          toggleOpen(clickEvent)
        }}
        >
          {label}
        </button>
        }
       
        { acfMegaMenu.columns != null && <SubMenu
          acfMegaMenu={acfMegaMenu.columns}
          parentOpen={open}
          pageScrolled={pageScrolled}

          level={level}
          parentRef={parentRef ? parentRef : null}
          locationPathName={locationPathName}
          setClosedAll={setClosedAll}
          closedAll={closedAll}
        />
        }

      </MenuListItem>
    )

}


function SubMenu({
  id,
  label,
  path,
  acfMegaMenu,
  level,
  locationPathName,
  parentOpen,
  pageScrolled,
  parentRef,
  setClosedAll,
  closedAll,
}) {
  const { setNavbarHovered } = useStateContext()
  const newLevel = level + 1
  const ul = useRef(null)

  const openClass = parentOpen ? "opacity-100 visible " : " opacity-0 invisible"
  const scrolledClass = pageScrolled ? "lg:top-c87" : "lg:top-c147"

  return (
    <div
      key={id}
      className={`mega-menu-wrapper fixed  left-0 bg-white w-full transition-all duration-200 ${scrolledClass} ${openClass}`}
      role="region"
      aria-haspopup="true"
      aria-expanded="false"
      tabIndex="0"
    >
      <div className="mega-menu-inner lg:px-c50 fhd:px-c100 py-10">
        <div className="mega-menu-grid grid grid-cols-4 2xl:grid-cols-6 gap-5">
          {acfMegaMenu.map(({ items }, index) => {
            return (
              <SubMenuItem
                key={`${id}-${index}`}
                items={items}
                level={newLevel}
                path={path}
                locationPathName={locationPathName}
                parentRef={ul}
              ></SubMenuItem>
            )
          })}
        </div>
      </div>
    </div>
  )
}
const SubMenuItem = ({
  id,
  label,
  path,
  items,
  parentOpen,
  parentRef,
  level,
  locationPathName,
  setClosedAll,
  closedAll,
 
}) => {
  
  const newLevel = level + 1
  return (
    <div className="single-column" key={id}>
      <ul className="mega-menu-items">
        {items.map(({ menuItem, menuTitle, subitems }, index) => {
          return (
            <MenuListItem
              level={level}
              className={`level-${level}`}
              active={menuItem.link === locationPathName}
              key={`${id}-${index}`}
            >
              {menuTitle != null && (
                <h3 className={`level-${level} menu-title`}>{menuTitle}</h3>
              )}

              <Link
                className={``}
                to={menuItem.link}
                title={menuItem.title}
                aria-label={menuItem.title}
                active={path === locationPathName}
              >
                {menuItem.title}
              </Link>

              {subitems != null && (
                <SubMenuSecond
                  className={`level-${level}`}
                  subitems={subitems}
                  parentOpen={parentOpen ? parentOpen : "noParrent"}
                  parentRef={parentRef ? parentRef : null}
                  level={newLevel}
                  locationPathName={locationPathName}
                  setClosedAll={setClosedAll}
                  closedAll={closedAll}
                />
              )}
            </MenuListItem>
          )
        })}
      </ul>
    </div>
  )
}

function SubMenuSecond({
  id,
  label,
  path,
  subitems,
  level,
  locationPathName,
  parentOpen,
  parentRef,
  setClosedAll,
  closedAll,
}) {
  return (
    <ul className="submenu-second" key={id}>
      {subitems.map((subitem, index) => {
        return (
          <MenuListItem
            key={`${id}-${index}`}
            className={`level-${level}`}
            level={level}
            active={subitem.submenuItem.link === locationPathName}
          >
            <Link
              className={``}
              to={subitem.submenuItem.link}
              title={subitem.submenuItem.title}
              aria-label={subitem.submenuItem.title}
            >
              {subitem.submenuItem.title}
            </Link>
          </MenuListItem>
        )
      })}
    </ul>
  )
}



const MenuListItem = motion(
  styled.li(({ level, active, pageScrolled }) => {

    switch (level) {
      case 0:
        return [
        
          tw`relative cursor-pointer font-ubuntu py-c50 lg:px-2`,
          {
            paddingTop: pageScrolled ? "20px" : "",
            paddingBottom: pageScrolled ? "20px" : "",
          },
          `
          transition-property: padding-top, padding-bottom;
          transition-duration: 0.2s;
          &.active-true {
            > button, > a {
              `,
                tw`font-bold tracking-wide`,
              `
            }
          }
          &.active-false {
            > button, > a {
              `,
                tw`font-normal tracking-bigWide`,
              `
            }
          }
          > button, > a {
            `,
              tw`lg:text-14 3xl:text-18 uppercase tracking-bigWide block font-ubuntu no-underline hover:no-underline last-of-type:pr-0`,
              {
                fontWeight: active ? "bold !important" : "normal",
                letterSpacing: active ? "0.025em !important" : "0.06em;",
              },
              {
                textDecoration: active ? "underline" : "none",
              },
            `
          }
         
          &:has(.level-1){
            `,
              tw`pr-5 3xl:pr-10`,
            `
            &::after {
              content: '';
              background-image: url("data:image/svg+xml,%3Csvg width='11' height='6' viewBox='0 0 11 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5.5 5L10 1' stroke='black' stroke-linecap='square' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
              `,
              tw`right-0 top-1/2 -translate-y-1/2 w-11px h-2.5 transition-transform duration-200 absolute bg-no-repeat bg-center bg-contain`,
            `}
            &.open-true {
              &::after {
                background-image: url("data:image/svg+xml,%3Csvg width='11' height='6' viewBox='0 0 11 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5.5 5L10 1' stroke='black' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
              `,
                tw`rotate-180`,
              `
              }
            }
          }

          `,
        ]
      case 1:
        return [
          tw`font-ubuntu mb-c50 last-of-type:mb-0`,
          `> a { 
            text-underline-offset: 2px;
            text-decoration-thickness: 0.02em;
          `,
            tw`font-bold text-20 normal-case pb-4 block`,
          `
          }
          &:has(.level-1.menu-title){
            .menu-title {
              `,
                tw`font-bold text-20 normal-case pb-4 block`,
              `
            }
            > a{
              `,
                tw`font-light text-16 normal-case pb-3 block`,
                {
                  textDecoration: active ? "underline" : "none",
                },
              `
              
            }
          }
          `,
         
        ]
      case 2:
        return [
          tw`pt-3 font-ubuntu first-of-type:pt-0`,
          `> a { 
            text-underline-offset: 2px;
            text-decoration-thickness: 0.02em;
          `,
            tw`font-light text-16 normal-case`,
             {
            textDecoration: active ? "underline" : "none",
            },
          `
          }`,
         
        ]
      default:
        return [
          {
            fontWeight: active ? "bold" : "normal",
            transformOrigin: "100% 0",
          },
          tw`relative p-3 ml-3 text-base text-black uppercase cursor-pointer  font-ubuntu last-of-type:pr-0`,
        ]
    }
  })
)
